import { city } from './helper/ValidatorRules'

const cityValidator = {
  getMessage: () => 'Sorry, only letters, and symbols (. - \') are allowed.',
  validate: value => {
    return {
      valid: city(value),
      data: {
        required: true
      }
    }
  }
}

export default cityValidator
